<template>
	<div id="reg" class="formstep col-12">
		<template v-if="currentStep !== 4">
			<div class="mb-5">
				<div v-if="block.block_title" class="row panel_header align-items-center">
					<div class="col-12 col-lg-9">
						<h2 class="mb-0">
							{{ block.block_title }}
						</h2>
					</div>
					<div class="col-12 col-lg-3">
						<span v-if="discount || isActivatePromocode" class="title">
							{{ createMaskAmount(selectedFlow.price) }} руб
						</span>
						<span v-else class="d-flex flex-column align-items-end">
							<span
								v-if="order.data.amount"
								class="title"
							>
								{{ createMaskAmount(currentPrice) }} руб
							</span>
							<span v-else class="title">{{ createMaskAmount(initialPrice) }} руб</span>
							<div
								v-if="order.data.hash && order.data.price_vat != 0"
								class=" text-right description small price_vat"
							>
								<!-- <div>Сумма без НДС: {{ createMaskAmount(order.data.amount_without_vat) }} руб</div>
								<div>НДС 20%: {{ createMaskAmount(order.data.price_vat) }} руб</div> -->
							</div>
						</span>
					</div>
				</div>
			</div>
			<div v-if="block.subtitle" class="col-12">
				<p>{{ block.subtitle }}</p>
			</div>

			<client-only>
				<div id="reg" class="row h-100 mt-4">
					<div ref="sticky-container" class="col-12 col-lg-2 sticky-container">
						<ProgressSteps :steps="stepsDynamic" :current="$auth.user ? currentStep : currentStep - 1 || 1" @change="setStep" />
					</div>
					<div v-if="currentStep === 1 || order" class="col-12 col-lg-8 py-0 px-lg-4">
						<KeepAlive>
							<component
								:is="currentComponent"
								:ref="currentComponent"
								:block="block"
								:final-price="finalPrice"
								:original-price="originalPrice"
								:fetched-data="fetchedData"
								:order="order"
								:payer-type="payerType"
								@submit="nextStep"
								@changePayerType="updatePayerType"
								@submitLoading="(value) => isLoading = value"
								@formSuccess="isAuth ? getFormData() : currentStep = FINISH_STEP"
								@setSelectedProducts="productChangeHandler"
								@changeNoEducation="educationChangeHandler"
								@changeNoEducationNonAuth="educationNonAuthChangeHandler"
							>
								<template #footer>
									<div v-if="isShowLoginWithCode" class="w-100 d-flex mb-4">
										<FormulateInput
											v-model="code"
											class="col-12 col-lg-6"
											type="text"
											label="Код подтверждения из письма"
											placeholder="Введите значение"
											@input="codeHandler"
										>
											<template #help>
												<div v-if="loginError" class="error">
													{{ loginError }}
												</div>
											</template>
										</FormulateInput>
									</div>
									<div class="w-100 d-flex">
										<FormulateInput
											id="submit"
											type="submit"
											class="submit mb-2 w-100"
											:disabled="isSubmitDisabled"
										>
											Продолжить
										</FormulateInput>
									</div>

									<template v-if="isShowLoginWithCode">
										<p class="text-primary text-center">
											Код авторизации отправлен на почту
										</p>
									</template>
								</template>
							</component>
						</KeepAlive>
					</div>
					<!--  Заготовка под блок информации  -->
					<div class="col-12 col-lg-2" />
				</div>
			</client-only>
		</template>
		<div v-else class="d-flex justify-content-center">
			<client-only>
				<SuccessStep />
			</client-only>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProgressSteps from '~/components/panels/formulate/components/ProgressSteps.vue';
import FirstStep from '~/components/panels/formulate/components/steps/FirstStep.vue';
import SecondStep from '~/components/panels/formulate/components/steps/SecondStep.vue';
import ThirdStep from '~/components/panels/formulate/components/steps/ThirdStep.vue';
import SuccessStep from '~/components/panels/formulate/components/steps/SuccessStep.vue';
import { STATUSES, FORM_PAYER_TYPE, LOYALTY_LEVELS } from '~/utils/dictionaries';
import { mapActions } from 'vuex';
import loyaltyPoints from '~/mixins/loyaltyPoints';

const STEPS_COMPONENT = {
	1: 'FirstStep',
	2: 'SecondStep',
	3: 'ThirdStep',
};

const FINISH_STEP = 4;

export default {
	name: 'LandingProgramWithStepsPaymentScenario',
	components: {
		ProgressSteps,
		FirstStep,
		SecondStep,
		ThirdStep,
		SuccessStep,
	},
	mixins: [formulateFormScenario, loyaltyPoints],
	provide() {
		const person = {};
		const loyalty = {};
		const order = {};

		Object.defineProperty(person, 'personData', {
			enumerable: true,
			get: () => this.personData,
		});

		Object.defineProperty(loyalty, 'loyaltyProfile', {
			enumerable: true,
			get: () => this.loyaltyProfile,
		});

		Object.defineProperty(loyalty, 'cardBackground', {
			enumerable: true,
			get: () => this.cardBackground,
		});

		Object.defineProperty(loyalty, 'awardedPoints', {
			enumerable: true,
			get: () => this.awardedPoints,
		});

		Object.defineProperty(loyalty, 'isBlockContainsLoyaltyChargeProduct', {
			enumerable: true,
			get: () => this.isBlockContainsLoyaltyChargeProduct,
		});

		Object.defineProperty(loyalty, 'isBlockContainsLoyaltyEarnProduct', {
			enumerable: true,
			get: () => this.isBlockContainsLoyaltyEarnProduct,
		});

		Object.defineProperty(order, 'data', {
			enumerable: true,
			get: () => this.order?.data,
		});

		Object.defineProperty(order, 'finalPrice', {
			enumerable: true,
			get: () => this.finalPrice,
		});

		Object.defineProperty(order, 'selectedFlow', {
			enumerable: true,
			get: () => this.selectedFlow,
		});

		Object.defineProperty(order, 'unauthAgreements', {
			enumerable: true,
			get: () => this.order.unauthAgreements,
		});

		return {
			person,
			loyalty,
			order,
			setExist: this.setUserExist,
		};
	},
	data() {
		return {
			FINISH_STEP,
			levels: LOYALTY_LEVELS,
			cardBackground: null,
			loyaltyProfile: {},
			isLoading: false,
			steps: [
				{ id: 1, title: 'Основная информация', completed: true },
				{ id: 2, title: 'Документы', completed: false },
			],
			currentStep: 1,
			order: {
				data: {
					products: [],
				},
			},
			personData: {},
			payerType: 2,
			isCheckEmailMessage: false,
			selectedFlow: null,
			currentProduct: null,
			isEducationChanged: {
				value: false,
				current: null,
			},
			loginError: null,
			code: null,
			currentEmail: null,
			isUserExist: false,
			isShowLoginWithCode: false,
			noEducation: '0',
		};
	},
	computed: {
		isAuth() {
			return this.$auth.user;
		},
		isPhysicalPayer() {
			return this.payerType === FORM_PAYER_TYPE.PHYSICAL;
		},
		stepsDynamic() {
			const paymentStep = {
				id: this.isAuth ? 3 : 2,
				title: (this.isPhysicalPayer ? 'Способ оплаты' : 'Оплатить по счету'),
				completed: false,
			};
			const formattedSteps = [...this.steps, paymentStep];
			return formattedSteps.map((step) => ({
				...step,
				// completed: this.personData.form_step > step.id,
				completed: this.currentStep > step.id,
				blocked: !this.personData.order_hash,
			})).filter((step) => (step.title === 'Документы' ? this.isAuth : true));
		},
		currentComponent() {
			return STEPS_COMPONENT[this.currentStep];
		},
		finalPrice() {
			if (!this.priceWithPromocode) {
				if (this.discountPrice > 0 && this.discount) return this.discountPrice;
				return this.can_return_vat_selected
					? this.priceWithoutVat
					: this.amount;
			}

			return this.priceWithPromocode;
		},
		originalPrice() {
			return this.can_return_vat_selected
				? this.priceWithoutVat
				: this.amount;
		},
		initialPrice() {
			const price = this.currentProduct
				? this.currentProduct.price
				: this.block?.products[0]?.price;
			if (!this.isAuth) {
				return !+this.noEducation ? price : price * 1.2;
			}
			return price;
		},
		currentPrice() {
			const { data: { price_with_manager_vat, amount_without_vat, amount } } = this.order;
			const { current, value } = this.isEducationChanged;
			const priceWhenChanged = Number(current) ? price_with_manager_vat : amount_without_vat;

			return value ? priceWhenChanged : amount;
		},
		priceWithoutVat() {
			return this.block?.products.reduce(
				(sum, product) => parseFloat(sum) + parseFloat(product?.price_without_vat ?? 0),
				0,
			);
		},
		savedVat() {
			return this.$store.state.cart.vat;
		},
		isSubmitDisabled() {
			// return this.isLoading || this.isCheckEmailMessage || (!this.isUserExist && this.isShowLoginWithCode);
			return this.isLoading || this.isCheckEmailMessage;
		},
	},
	watch: {
		'$auth.user': {
			async handler(user) {
				if (user) {
					await this.getLoyaltyProfile();
				}
			},
			immediate: true,
		},
		isCookiesAccepted: {
			handler(value) {
				if (value) { this.isLoading = false; }
			},
		},
	},
	async created() {
		await this.getFormData();
		await this.fetchAwardedPoints();
	},
	methods: {
		...mapActions('authModal', ['showLogin', 'setNeedReload']),
		async stepRecognize() {
			const hash = this.personData.order_hash;
			if (hash) {
				this.currentStep = this.personData.form_step;
				await this.getOrder(hash);
			}
		},
		async getPersonData() {
			try {
				const { data } = await this.$api.getPersonOnPayment(this.block.scenario_id);
				if (this.isAuth) {
					this.payerType = data.payer_type ?? FORM_PAYER_TYPE.PHYSICAL;
				}
				this.personData = data;
			} catch (e) {
				console.error(e);
			}
		},
		async getFormData() {
			await this.getPersonData();
			await this.stepRecognize();
		},
		async getOrder(hash) {
			let order = null;
			let fetchedData = null;
			await this.$api.orderInfo(hash)
				.then(async (res) => {
					order = res;
					if (order.data?.landing) {
						fetchedData = await this.$api.event(order.data.landing.slug);
					}
					this.order = order;
				})
				.catch(async (error) => {
					console.error(error);

					if (error.response?.status === STATUSES.NOT_FOUND) {
						if (order.data.landing) {
							const url = new URL(order.data.landing.url);
							fetchedData = await this.$api.axios.$get(`api/pages${url.pathname}`);
						}
					}
				});
		},
		updatePayerType(id) {
			if (id) this.payerType = id;
		},
		async updateFormStep(step) {
			if (!this.isAuth) return;
			if (this.personData.form_step > step) return;
			await this.$api.updateFormStep(this.personData.order_hash, step);
		},
		async nextStep(hash = null, step) {
			// Процесс авторизации нового пользователя
			// if (this.currentStep === 1 && !this.isUserExist) {
			// 	await this.getPersonData();
			// 	await this.sendCode();
			// 	this.isShowLoginWithCode = true;
			// 	return;
			// }
			let dynamicStep = step || this.currentStep;
			if (!this.isAuth) {
				dynamicStep += 1;
			}
			if (dynamicStep < FINISH_STEP) {
				await this.getPersonData();

				this.personData.order_hash = hash || this.personData.order_hash;
				if (this.$auth.user) {
					await this.getPersonData();
				}
				// if (this.$auth.user) {
				// 	await this.getPersonData();
				// } else {
				// 	await this.$api.sendAutologinEmail(hash);
				// 	this.isCheckEmailMessage = true;
				// 	return;
				// }
				await this.getOrder(this.personData.order_hash);
			}

			if (step) {
				this.currentStep = dynamicStep;
			} else {
				this.currentStep = dynamicStep + 1;
			}
			await this.updateFormStep(this.currentStep);
		},
		async setStep(id) {
			if (this.currentStep < 3) {
				if (this.order?.id && this.currentStep === 1) return;
				// Вызов отправки формы при изменении шага
				this.$refs[this.currentComponent]?.submitHandler({}, true, id);
				return;
			}
			this.currentStep = id;
			await this.updateFormStep(id);
		},
		async getLoyaltyProfile() {
			const { data } = await this.$api.getLoyaltyProfile();

			if (data) {
				this.loyaltyProfile = data;
				const [currentLevel] = this.levels?.filter((el) => el.id === this.loyaltyProfile.level.id);
				this.cardBackground = currentLevel.color;
			}
		},
		showLoginModal() {
			this.showLogin();
			this.setNeedReload(true);
		},
		setSelectedProducts(product) {
			this.selectedFlow = this.allProductsFromGroup.find((el) => el.id == product.products);
		},
		productChangeHandler(data) {
			if (!this.block?.products.length) return;
			this.currentProduct = this.block?.products.find((product) => +product.id === +data.products);
		},
		educationChangeHandler(data) {
			this.isEducationChanged.value = true;
			this.isEducationChanged.current = data;
		},
		educationNonAuthChangeHandler(value) {
			this.noEducation = value;
		},
		setUserExist(value, email) {
			this.isUserExist = value;
			this.currentEmail = email;
		},
		async sendCode() {
			try {
				await this.$api.codeGenerate({ email: this.currentEmail });
			} catch (error) {
				try {
					const {
						message,
					} = this.$api.getValidationFromError(error);
					this.loginError = message;
				} catch {
					console.error(error);
					this.loginError = 'Что-то пошло не так';
				}
			}
		},
		async codeHandler() {
			if (this.code.length === 6) {
				await this.loginWithCode();
			}
		},
		async loginWithCode() {
			try {
				await this.$auth.loginWith('code', {
					data: {
						code: this.code,
						email: this.currentEmail,
					},
				}).then((res) => {
					if (res.data?.data) {
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							event: 'login',
							user_id: res.data.data.id,
							counterparty_type: res.data.data.counterparty_type ? 'Корпоративный клиент' : 'Физическое лицо',
						});
					}
				});
				this.isUserExist = true;
				await this.nextStep();
				this.isShowLoginWithCode = false;
			} catch (error) {
				try {
					const {
						message,
					} = this.$api.getValidationFromError(error);
					this.loginError = message;
				} catch {
					console.error(error);
					this.loginError = 'Что-то пошло не так';
				}
			}
		},
	},
};
</script>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formstep {
	.formulate-input {
		.formulate-input-label {
			color: $body-color;
			line-height: 1 !important;
			font-size: 80% !important;
			font-weight: 400 !important;
			margin-bottom: 0.5rem;
		}
	}

	.price_vat {
		color: $border-color;
		font-size: 0.8rem;
		line-height: 1rem;
	}

	// .submit.btn.btn-secondary {
	// 	background-color: $primary !important;

	// 	&:disabled {
	// 		background-color: $border-color !important;

	// 		&:hover {
	// 			border-color: unset !important;
	// 		}
	// 	}
	// }
	.submit {
		button {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.sticky-container {
		@include media-breakpoint-up(lg) {
			height: 100% !important;
		}
	}
}
</style>
